module.exports = __webpack_public_path__ + "assets/img/logo_IVE_Bianco.cf3924cc.png";